import Component from 'vue-class-component';
import Vue from 'vue';

@Component
export default class ErrorComponent extends Vue {
    public message: string = '';
    public returnUrl: string = '/';

    public mounted() {
        this.message = this.$route.params.message;

        const r = this.$route.params.returnUrl;
        if (r !== undefined) {
            this.returnUrl = r;
        }
    }
}
